import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import azTranslation from './locales/az/translation.json';
import ruTranslation from './locales/ru/translation.json';

const resources = {
  az: {
    translation: azTranslation
  },
  ru: {
    translation: ruTranslation
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: process.env.REACT_APP_LANG,
    fallbackLng: process.env.REACT_APP_LANG,
    interpolation: {
      escapeValue: false,
    }
  });

export default i18n;
